import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input, Output } from 'angular-ts-decorators';
import { ProductContextService } from 'src/Foundation/Design/app';
import { setDefaultReportPageInfo } from '../utils/set-default-report-page-info';
import { setWtuAdditionalInfo } from '../utils/set-wtu-additional-info';
import template from './report-page-form.component.html';
var ReportPageFormComponent = (function () {
    function ReportPageFormComponent(productContextService, wasThisUseful) {
        this.productContextService = productContextService;
        this.wasThisUseful = wasThisUseful;
        this.feedbackText = '';
        this.loading = false;
        this.reported = false;
    }
    ReportPageFormComponent.prototype.submit = function () {
        var _this = this;
        this.loading = true;
        var model = {
            feedbackText: this.feedbackText,
            useful: false,
        };
        setDefaultReportPageInfo(model, this.spotName);
        setWtuAdditionalInfo(model, this.productContextService.getContext());
        this.wasThisUseful.sendInitialResponse(model)
            .then(function () {
            _this.reported = true;
            _this.loading = false;
            if (_this.onReport) {
                _this.onReport();
            }
        });
    };
    ReportPageFormComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ReportPageFormComponent.prototype, "sendFeedbackButtonLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ReportPageFormComponent.prototype, "textareaLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ReportPageFormComponent.prototype, "spotName", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], ReportPageFormComponent.prototype, "onReport", void 0);
    ReportPageFormComponent = __decorate([
        Component({
            selector: 'reportPageForm',
            template: template,
            transclude: true,
        }),
        __param(0, Inject('productContextService')),
        __param(1, Inject('wasThisUseful')),
        __metadata("design:paramtypes", [ProductContextService, Object])
    ], ReportPageFormComponent);
    return ReportPageFormComponent;
}());
export { ReportPageFormComponent };
